import * as logger from '../utils/logger';
import { KARRIERE_ATS_USER_UUID } from '../utils/constants/atsUser';
import {
    BACKEND,
    apiEndpoint,
} from '../utils/api';
import { useApplicationStore } from '../stores/application-store';

export async function saveApplication(state) {
    const {
        application,
        gdprTexts,
        payload,
        customFields,
        meta,
    } = state;

    let policy = null;
    let consent = null;

    // If it is a karriere.at job, the externalId of the generalPolicy is set.
    // Else if a company has pushed a policy, the externalId of the companyPolicy is set.
    // Otherwise, the externalId in companyPolicy is null.
    if (payload.atsUserUuid === KARRIERE_ATS_USER_UUID) {
        policy = gdprTexts.generalPolicy.legalTextExternalId;
    } else if (gdprTexts.companyPolicyChecked) {
        policy = gdprTexts.companyPolicy.legalTextExternalId;
    }

    // If a company consent is available and the user has agreed to it, then the externalId is set.
    // Otherwise, the externalId in companyConsent is null.
    if (gdprTexts.companyConsent && gdprTexts.companyConsentChecked) {
        consent = gdprTexts.companyConsent.legalTextExternalId;
    }

    const data = {
        atsUserUuid: payload.atsUserUuid,
        attachments: application.serializedAttachments,
        consent,
        customFields,
        email: application.email,
        firstname: application.firstname,
        message: application.applicationLetter,
        meta,
        salutation: application.salutation,
        sendCopyToApplicant: true,
        surname: application.lastname,
        payload: payload.encryptedPayload,
        policy,
    };

    const { id } = await apiEndpoint({
        api: BACKEND,
        endpoint: 'applications',
        options: {
            headers: {
                'recaptcha-response': application.recaptchaResponse,
            },
        },
        accessToken: state.profile.accessToken,
    })
        .post('', data)
        .then(response => response.data)
        .catch((exception) => {
            logger.error({
                exception,
                fingerprint: ['Saving application failed.'],
                message: 'Saving application failed.',
                extra: {
                    request: JSON.stringify(data),
                    response:
                        exception.response && exception.response.data ?
                            JSON.stringify(exception.response.data) :
                            'No response available.',
                    profile: state.profile,
                },
            });
            throw exception;
        });

    const applicationStore = useApplicationStore();
    applicationStore.updateUuid(id);
}
